import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import CardContent from '../components/CardContent.js';
import Card from '../Card.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Button from '../../Button/Button.js';

var _excluded = ["image", "imageOverlay", "lazy", "externalImage", "imageAspectRatio", "tags", "title", "headingLevel", "subtitle", "description", "buttonText", "buttonVariant", "url", "onClick", "onClickElementProps", "linkList", "imagePosition", "children", "withBackground"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ArticleCard = function ArticleCard(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$imageOverlay = _ref.imageOverlay,
    imageOverlay = _ref$imageOverlay === void 0 ? null : _ref$imageOverlay,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$externalImage = _ref.externalImage,
    externalImage = _ref$externalImage === void 0 ? null : _ref$externalImage,
    _ref$imageAspectRatio = _ref.imageAspectRatio,
    imageAspectRatio = _ref$imageAspectRatio === void 0 ? null : _ref$imageAspectRatio,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? null : _ref$tags,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? null : _ref$headingLevel,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? 'secondary' : _ref$buttonVariant,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$onClickElementPr = _ref.onClickElementProps,
    onClickElementProps = _ref$onClickElementPr === void 0 ? null : _ref$onClickElementPr,
    _ref$linkList = _ref.linkList,
    linkList = _ref$linkList === void 0 ? null : _ref$linkList,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'top' : _ref$imagePosition,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$withBackground = _ref.withBackground,
    withBackground = _ref$withBackground === void 0 ? undefined : _ref$withBackground,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isGlobetrotter = useIsGlobetrotter();
  return /*#__PURE__*/jsx(Card, _objectSpread(_objectSpread({}, rest), {}, {
    image: image,
    imageOverlay: imageOverlay,
    imagePosition: imagePosition,
    lazy: lazy,
    imageAspectRatio: imageAspectRatio,
    externalImage: externalImage,
    onClick: onClick,
    onClickElementProps: onClickElementProps,
    url: url,
    variant: "article",
    noBackground: withBackground !== undefined ? !withBackground : isGlobetrotter,
    children: /*#__PURE__*/jsxs(CardContent, {
      tags: tags,
      title: title,
      subtitle: subtitle,
      description: description,
      linkList: linkList,
      headingLevel: headingLevel,
      children: [children, buttonText && /*#__PURE__*/jsx(Button, {
        className: "uikit-article-card-button",
        variant: buttonVariant,
        size: isGlobetrotter ? 's' : 'm',
        children: buttonText
      })]
    })
  }));
};
var ArticleCard$1 = ArticleCard;

export { ArticleCard$1 as default };
//# sourceMappingURL=ArticleCard.js.map
